// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeroSection_hero-section__container-default-v1 {
    max-width: 700px  !important;
}
.ApproachSection_approach-section__heading--title-default-v1 {
    font-size: 60px;
    font-weight: 800;
    line-height: 66px;
    margin-bottom: 1.5rem
}
.SearchSection_search-section__heading-default-v1 {
    font-size: 28px;
    font-weight: 600;
    line-height: 1.1;
    text-align: center;
    margin: 0 0 18px;
    color: #3E3E3E;
}   
.ApproachSection_approach-section__heading--subtitle-default-v1 {
 font-size: 20px !important;
 margin: 7px 0;

}
.ProfessionalsSection_professionals-section_-default-v1 {
    background: linear-gradient(180deg, rgba(219, 219, 218, 1) 0%, rgba(255, 253, 227, 1) 100%);

}

 
@media only screen and (max-width: 1060px) {
    .HeroSection_hero-section__heading-default-v1 {
    font-size: 47px !important;
    font-weight: 800;
    line-height: 3rem;
    margin-bottom: 1.5rem;
}
.ApproachSection_approach-section__text-default-v1 {
line-height: 1.55 !important;
font-size: 15px !important;
text-align: center !important;
}
.ProfessionalsSection_professionals-section__text-default-v1 {
line-height: 1.55 !important;
font-size: 15px !important;
}
.ReserveNow_reserve-now__text-default-v1 {
line-height: 1.55 !important;
font-size: 15px !important;
}
.StepsProcessSection_steps-process-section__step-text-default-v1 {
    font-size: 15px !important;
    line-height: 1.3 !important;
}
.WhySection_why-section__text-default-v1, .ActionIntroSection_action-intro-section__text-default-v1 {
line-height: 1.55 !important;
font-size: 15px !important;
}
.ProfessionalsSection_professionals-section-default-v1, .StepsProcessSection_steps-process-section-default-v1 {
    padding: 120px 80px !important;
}
}

:root {
    --bw-semantic-error: #D95C5C;
    --bw-error-soft: rgba(217,92,92,.88);
}

.bw-toast {
    position: absolute; left: 24px; bottom: 22px;
    width: min(520px, calc(100% - 48px));
    display: flex; gap: 14px; align-items: flex-start;
    padding: 16px 18px;
    border-radius: var(--bw-radius-lg, 18px);
    background: var(--bw-card-surface, #F7F5F1);
    border: 1px solid rgba(130,177,148,.28);
    box-shadow: 0 18px 34px rgba(18,34,28,.12);
    z-index: 7;
}

.bw-message {
    position: fixed;
    bottom: 22px;
    left: 24px;
    max-width: 520px;
    display: flex;
    gap: 14px;
    align-items: flex-start;
    padding: 16px 18px;
    border-radius: var(--bw-radius-lg, 12px);
    background: #ffffff;
    border: 1px solid rgba(0,0,0,0.06);
    box-shadow: 0 12px 28px rgba(0,0,0,0.08);
    z-index: 1400;
}

.error-text, .validation-error {
    color: var(--bw-error-soft, rgba(217,92,92,.88));
    font-weight: 600 !important;
}

input:focus,
input:focus-visible,
textarea:focus,
textarea:focus-visible,
select:focus,
select:focus-visible {
    outline: none !important;
    border-color: #82B194 !important;
    box-shadow: 0 0 0 2px rgba(130, 177, 148, 0.25) !important;
}

`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;AACA;CACC,0BAA0B;CAC1B,aAAa;;AAEd;AACA;IACI,2FAA2F;;AAE/F;;;AAGA;IACI;IACA,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;AACA;AACA,4BAA4B;AAC5B,0BAA0B;AAC1B,6BAA6B;AAC7B;AACA;AACA,4BAA4B;AAC5B,0BAA0B;AAC1B;AACA;AACA,4BAA4B;AAC5B,0BAA0B;AAC1B;AACA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;AACA,4BAA4B;AAC5B,0BAA0B;AAC1B;AACA;IACI,8BAA8B;AAClC;AACA;;AAEA;IACI,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;IACI,kBAAkB,EAAE,UAAU,EAAE,YAAY;IAC5C,oCAAoC;IACpC,aAAa,EAAE,SAAS,EAAE,uBAAuB;IACjD,kBAAkB;IAClB,wCAAwC;IACxC,2CAA2C;IAC3C,uCAAuC;IACvC,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,kCAAkC;IAClC,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,gDAAgD;IAChD,2BAA2B;AAC/B;;AAEA;;;;;;IAMI,wBAAwB;IACxB,gCAAgC;IAChC,0DAA0D;AAC9D","sourcesContent":[".HeroSection_hero-section__container-default-v1 {\n    max-width: 700px  !important;\n}\n.ApproachSection_approach-section__heading--title-default-v1 {\n    font-size: 60px;\n    font-weight: 800;\n    line-height: 66px;\n    margin-bottom: 1.5rem\n}\n.SearchSection_search-section__heading-default-v1 {\n    font-size: 28px;\n    font-weight: 600;\n    line-height: 1.1;\n    text-align: center;\n    margin: 0 0 18px;\n    color: #3E3E3E;\n}   \n.ApproachSection_approach-section__heading--subtitle-default-v1 {\n font-size: 20px !important;\n margin: 7px 0;\n\n}\n.ProfessionalsSection_professionals-section_-default-v1 {\n    background: linear-gradient(180deg, rgba(219, 219, 218, 1) 0%, rgba(255, 253, 227, 1) 100%);\n\n}\n\n \n@media only screen and (max-width: 1060px) {\n    .HeroSection_hero-section__heading-default-v1 {\n    font-size: 47px !important;\n    font-weight: 800;\n    line-height: 3rem;\n    margin-bottom: 1.5rem;\n}\n.ApproachSection_approach-section__text-default-v1 {\nline-height: 1.55 !important;\nfont-size: 15px !important;\ntext-align: center !important;\n}\n.ProfessionalsSection_professionals-section__text-default-v1 {\nline-height: 1.55 !important;\nfont-size: 15px !important;\n}\n.ReserveNow_reserve-now__text-default-v1 {\nline-height: 1.55 !important;\nfont-size: 15px !important;\n}\n.StepsProcessSection_steps-process-section__step-text-default-v1 {\n    font-size: 15px !important;\n    line-height: 1.3 !important;\n}\n.WhySection_why-section__text-default-v1, .ActionIntroSection_action-intro-section__text-default-v1 {\nline-height: 1.55 !important;\nfont-size: 15px !important;\n}\n.ProfessionalsSection_professionals-section-default-v1, .StepsProcessSection_steps-process-section-default-v1 {\n    padding: 120px 80px !important;\n}\n}\n\n:root {\n    --bw-semantic-error: #D95C5C;\n    --bw-error-soft: rgba(217,92,92,.88);\n}\n\n.bw-toast {\n    position: absolute; left: 24px; bottom: 22px;\n    width: min(520px, calc(100% - 48px));\n    display: flex; gap: 14px; align-items: flex-start;\n    padding: 16px 18px;\n    border-radius: var(--bw-radius-lg, 18px);\n    background: var(--bw-card-surface, #F7F5F1);\n    border: 1px solid rgba(130,177,148,.28);\n    box-shadow: 0 18px 34px rgba(18,34,28,.12);\n    z-index: 7;\n}\n\n.bw-message {\n    position: fixed;\n    bottom: 22px;\n    left: 24px;\n    max-width: 520px;\n    display: flex;\n    gap: 14px;\n    align-items: flex-start;\n    padding: 16px 18px;\n    border-radius: var(--bw-radius-lg, 12px);\n    background: #ffffff;\n    border: 1px solid rgba(0,0,0,0.06);\n    box-shadow: 0 12px 28px rgba(0,0,0,0.08);\n    z-index: 1400;\n}\n\n.error-text, .validation-error {\n    color: var(--bw-error-soft, rgba(217,92,92,.88));\n    font-weight: 600 !important;\n}\n\ninput:focus,\ninput:focus-visible,\ntextarea:focus,\ntextarea:focus-visible,\nselect:focus,\nselect:focus-visible {\n    outline: none !important;\n    border-color: #82B194 !important;\n    box-shadow: 0 0 0 2px rgba(130, 177, 148, 0.25) !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
